import { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import './index.css';

import useScrollAnimations from './lib/useScrollAnimations';
import Icon from './components/Icon';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Portfolio from './pages/Portfolio';
import CaseStudy from './pages/CaseStudy';
import Process from './pages/Process';
import Blog from './pages/Blog';
import Life from './pages/Life';
import BlogPost from './pages/BlogPost';
import ContactPage from './pages/ContactPage';
import Legal from './pages/Legal';
import NotFound from './pages/NotFound';

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const on = () => setShow(window.scrollY > 700);
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, []);
  const top = () => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: 'smooth' }));
  return (
    <button
      onClick={top}
      aria-label="Back to top"
      className={`fixed bottom-6 right-6 z-40 grid h-12 w-12 place-items-center rounded-full bg-brand text-white shadow-xl transition-all duration-300 hover:-translate-y-1 ${show ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'}`}
    >
      <Icon name="up" strokeWidth={2.4} />
    </button>
  );
}

export default function App() {
  const { pathname } = useLocation();
  useScrollAnimations(pathname);

  return (
    <>
      <div className="scroll-progress fixed inset-x-0 top-0 z-[60] h-1 origin-left scale-x-0 bg-gradient-to-r from-brand to-brand-dark" />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:slug" element={<CaseStudy />} />
          <Route path="/process" element={<Process />} />
          <Route path="/life" element={<Life />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<Legal type="privacy" />} />
          <Route path="/terms" element={<Legal type="terms" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}
